//请自行添加语言资源
const mat = {
  skuCode: '产品编码',
  skuName: '产品名称',
  shipperCode: '所属客户编码',
  shipperName: '所属客户',
  skuLength: '长(M)',
  skuWidth: '宽(M)',
  skuHeight: '高(M)',
  unitVolume: '体积(M3)',
  unitWeight: '重量(kg)',
  unitNetWeight: '净重(kg)',
  unit: '单位',
  activeOff: '是否启用',
  activeOffDesc: '是否启用',
  useCompanyCode: '使用机构',
  useCompanyName: '使用机构',
  isDefault: '是否默认',
  msg: {
    skuCode : '请输入产品编码',
    skuName : '请输入产品名称',
    shipperCode : '请选择所属客户',
    activeOff: '请选择启用',
    isDefault: '请选择是否默认',
    skuLength: '长(M)只能输入数字',
    skuWidth: '宽(M)只能输入数字',
    skuHeight: '高(M)只能输入数字',
    unitVolume: '体积(M3)只能输入数字',
    unitWeight: '重量(kg)只能输入数字',
    unitNetWeight: '净重(kg)只能输入数字'
  }
};
export default mat



// WEBPACK FOOTER //
// ./src/page/mdm/mat/lang/mat.zh.js